<template>
  <div>
  <ValidationObserver
    ref="form"
    v-slot="{ handleSubmit, errors }"
    :disabled="true"
    slim
  >
    <form
      role="form"
      class="form-horizontal"
      @submit.prevent="handleSubmit(addValue)"
    >
      <div class="m-b-15">
        <div class="display-flex flex--align-center">
          <ValidationProvider
            v-slot="{ classes }"
            ref="txtKey"
            vid="txtKey"
            rules="required"
            slim
          >
            <input
              id="key"
              ref="keyEl"
              v-model="input.key"
              name="txtKey"
              class="http-header__input form-control m-b-0"
              :class="classes"
              autocomplete="off"
              placeholder="key"
            >
          </ValidationProvider>
          <div class="http-header__separator m-l-10 m-r-10">
            :
          </div>
          <ValidationProvider
            v-slot="{ classes }"
            ref="txtValue"
            vid="txtValue"
            rules="required"
            slim
          >
            <input
              id="value"
              ref="valueEl"
              v-model="input.value"
              name="txtValue"
              :class="classes"
              class="http-header__input form-control m-b-0"
              autocomplete="off"
              placeholder="value"
            >
          </ValidationProvider>
      
          <template v-if="enableMacros">
            <button
              :id="tokenButtonHeaderValue"
              :ref="tokenButtonHeaderValue"
              v-t="'TOKEN'"
              class="btn btn-secondary"
              type="button"
              @click="toggleMacrosPopover"
            />
            <popover
              v-model="showMacrosPopover"
              custom-class="breakdown-legend__popover"
              placement="bottom"
              trigger="manual"
              :target="'#' + tokenButtonHeaderValue"
              @show="tagsPopoverVisible = true"
              @hide="tagsPopoverVisible = false"
            >
              <template slot="popover">
                <MacroSelectionPopover
                  :focus-dropdown="tagsPopoverVisible"
                  :trigger-element="$refs[tokenButtonHeaderValue]"
                  :macros="macros"
                  @blur="showMacrosPopover = false"
                  @selected-tag="onSelectedTag"
                />
              </template>
            </popover>
          </template>
          <button
            v-t="'ADD'"
            type="submit"
            class="btn btn-success btn-sm m-l-15"
          />
        </div>
        <label
          v-if="showErrorMessage(errors)"
          v-t="'KEY_VALUE_REQUIRED'"
          class="form-group__label-error-message"
        />
      </div>
      <table class="table_beauty">
        <tbody>
          <tr
            v-for="(col, index) in valueColumns"
            :key="index"
          >
            <td class="word-break-all">
              {{ col.key }} : {{ col.value }}
            </td>
            <td>
              <div class="action-icon text-right">
                <a
                  class="btn btn-list-function"
                  @click="remove(col.key)"
                >
                  <i
                    v-tooltip.bottom.hover="$t('DELETE')"
                    class="fa fa-trash"
                    aria-hidden="true"
                  />
                </a>
              </div>
            </td>
          </tr>
          <tr
            v-if="valueColumns.length == 0"
          >
            <td
              v-t="'NO_HEADERS'"
              colspan="100%"
            />
          </tr>
        </tbody>
      </table>
    </form>
  </ValidationObserver>
</div>

</template>

<script>
import sharedMessages from '@/core/locales';
import { mapActions, mapState } from 'vuex';
import { GET_MACROS } from '@/modules/info/store/actionTypes';
import MacroSelectionPopover from '@/core/components/MacroSelectionPopover';
import { uniqueId } from 'lodash';

export default {
  name: 'HttpHeaders',
  components: { MacroSelectionPopover },
  props: {
    value: {
      type: Object,
      default: () => ({})  // Empty object
    },
    enableMacros: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      input: {},
      tagsPopoverVisible: false,
      showMacrosPopover: false,
      tokenButtonHeaderValue: this.generateRandomRefForToken(),
    };
  },
  async mounted() {
    await this.getMacros();
  },
  computed: {
    ...mapState('info', ['macros']),
    valueColumns() {
      const entries = Object.entries(this.value);
      return entries.map(([key, value]) => { return { key, value }; });
    }
  },
  methods: {
    ...mapActions('info', { 'getMacros': GET_MACROS }),
    toggleMacrosPopover() {
      this.showMacrosPopover = !this.showMacrosPopover;
    },
    notifyUp(value) {
      this.$emit('input', value);
    },
    remove(key) {
      const clonedValues = { ...this.value };
      delete clonedValues[key];
      this.notifyUp(clonedValues);
    },
    addValue() {
      if (this.input.key && this.input.value) {
        const clonedValues = { ...this.value };
        clonedValues[this.input.key] = this.input.value;
        this.input = {};
        this.$refs.form.reset();
        this.notifyUp(clonedValues);
      }
    },
    showErrorMessage(errors) {
      return errors && (errors['txtKey']?.length > 0 || errors['txtValue']?.length > 0);
    },
    generateRandomRefForToken() {
      return uniqueId('tokenButtonHeaderValue')
    },
    onSelectedTag(tag) {
      const valueEl = this.$refs.valueEl;
      const cursorPosition = valueEl.selectionStart;
      this.showMacrosPopover = false;
      const tagToAdd = tag.originalTag.macro;
      this.input.value = this.input.value ? this.input.value.substring(0, cursorPosition) + tagToAdd + this.input.value.substring(cursorPosition) : tagToAdd;
      this.$nextTick(() => {
        valueEl.focus();
        valueEl.selectionStart = cursorPosition + tagToAdd.length;
        valueEl.selectionEnd = cursorPosition + tagToAdd.length;
      });
    },
  },
  i18n: {
    sharedMessages,
    locale: 'en',
  },
};
</script>